/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { fetchGraphQl } from '@/quote-management/api';
import { GET_QUOTE_TEMPLATE_DATA } from './graphql/getQuoteTemplateData';
import { transformQuoteTemplate } from '@/quote-management/data/transforms';
import { NegotiableQuoteTemplateModel } from '@/quote-management/data/models/negotiable-quote-template-model';
import { state } from '@/quote-management/lib/state';
import { events } from '@adobe-commerce/event-bus';

export const getQuoteTemplateData = async (templateId: string): Promise<NegotiableQuoteTemplateModel | null> => {

  if (!state.authenticated) {
    throw new Error('Unauthorized');
  }

  if (!templateId) {
    throw new Error('Template ID is required');
  }

  try {
    const results: any = await fetchGraphQl(GET_QUOTE_TEMPLATE_DATA, {
      variables: { templateId },
    });


    if (!results?.data?.negotiableQuoteTemplate) {
      throw new Error('Quote template not found');
    }

    const transformedData = transformQuoteTemplate(results.data.negotiableQuoteTemplate);

    if (!transformedData) {
      throw new Error('Failed to transform quote template data');
    }

    events.emit('quote-management/quote-template-data', {
      quoteTemplate: transformedData,
      permissions: state.permissions,
    });

    return transformedData;
  } catch (error) {
    return Promise.reject(error);
  }
};
